import { axiosAuth } from "../axios";

const userBaseUrl = "private/user";

export const find = async (id?: string): Promise<any> => {
  const url = id ? `${userBaseUrl}/${id}` : userBaseUrl;
  const res = await axiosAuth.get(url);
  return res.data;
};
